// extracted by mini-css-extract-plugin
module.exports = {"priceRating":"index__priceRating___3J-xg","fadedPrice":"index__fadedPrice___1qlVV"};